import {fetchData} from "./utils/common";

const AriaLabelMessages = {
  ADD: `Добавить в избранное`,
  REMOVE: `Удалить из избранного`,
};

const TextMessages = {
  ADD: `в избранное`,
  REMOVE: `в избранном`,
};

const setAriaLabel = (element, message) => {
  if (element.ariaLabel) {
    element.ariaLabel = message;
  }
};

const setTextMessage = (element, message) => {
  if (element) {
    element.textContent = message;
  }
};

const addFavorite = ({
  addFavoriteSelector = `.js-add-favorite`,
  addFavoriteTextSelector = `.js-add-favorite-text`,
  addFavoriteToListLinkSelector = `.js-add-favorite-link`,
  activeClass = `active`,
}) => {
  const linkToFavoritsElement = document.querySelector(addFavoriteToListLinkSelector);

  const state = {
    current: {},
    id: ``,
  };

  const URL = `/basket/favorites`;
  const FAVORITE_PAGE_URL = `/favorites`;

  document.addEventListener(`click`, async (evt) => {
    if (
      evt.target.classList.contains(addFavoriteSelector) ||
      evt.target.closest(addFavoriteSelector)
    ) {
      evt.preventDefault();
      const button = evt.target.classList.contains(addFavoriteSelector)
        ? evt.target.classList.contains(addFavoriteSelector)
        : evt.target.closest(addFavoriteSelector);
      const textMesasgeElement = button.querySelector(addFavoriteTextSelector);

      state.id = button.dataset.id;

      const result = await fetchData(URL, state);

      if (result) {
        if (result.isFavorite) {
          button.classList.add(activeClass);
          setAriaLabel(button, AriaLabelMessages.REMOVE);
          setTextMessage(textMesasgeElement, TextMessages.REMOVE);
        } else {
          button.classList.remove(activeClass);
          setAriaLabel(button, AriaLabelMessages.ADD);
          setTextMessage(textMesasgeElement, TextMessages.ADD);

          if (location.pathname === FAVORITE_PAGE_URL) {
            evt.target.closest(`.cathegory__item`).remove();
          }
        }
        if (result.isNotEmptyList) {
          linkToFavoritsElement.classList.add(activeClass);
        } else {
          linkToFavoritsElement.classList.remove(activeClass);
        }
      }
    }
  });
};

export default addFavorite;
